/**
 * WP Go Maps marker listing overrides.
 *
 * Responsibilities:
 * - Force marker listing pagination page size.
 * - Override pagination previous / next labels.
 * - Render and maintain a count row above each marker listing
 *   (example: "97 toimipistettä").
 *
 * This script is loaded only on pages where WPGMZA pagination is present.
 */
(function () {
	var settings = window.puhtiVitalWpgmzaPagination || {};
	var pageSize = parseInt(settings.pageSize, 10);
	var prevText = settings.prevText || '';
	var nextText = settings.nextText || '';
	var countLabel = settings.countLabel || '';
	var retries = 0;
	var maxRetries = 40;
	var prototypePatched = false;

	if (isNaN(pageSize) || pageSize <= 0) {
		pageSize = 20;
	}

	/**
	 * Gets the fixed header offset made up of the navbar and admin bar.
	 */
	function getScrollOffset() {
		var navbars = document.querySelectorAll('.navbar');
		var rootStyles = window.getComputedStyle(document.documentElement);
		var adminBarHeight = parseFloat(
			rootStyles.getPropertyValue('--wp-admin--admin-bar--height')
		);
		var navbarHeight = 0;
		var i = 0;

		for (i = 0; i < navbars.length; i++) {
			var navbar = navbars[i];
			var styles = window.getComputedStyle(navbar);
			var height = 0;

			if (styles.display === 'none' || styles.visibility === 'hidden') {
				continue;
			}

			height = navbar.offsetHeight || navbar.getBoundingClientRect().height || 0;
			navbarHeight = Math.max(navbarHeight, height);
		}

		if (isNaN(adminBarHeight)) {
			adminBarHeight = 0;
		}

		return navbarHeight + adminBarHeight;
	}

	/**
	 * Scrolls the page so that the top of the marker listing is visible.
	 */
	function scrollToListing(listing) {
		if (!listing || !listing.element) {
			return;
		}

		var $el = jQuery(listing.element);
		var $counter = $el.prev('.wpgmza-marker-count');
		var $target = $counter.length ? $counter : $el;
		var offset = $target.offset();
		var scrollOffset = getScrollOffset();

		if (offset) {
			window.scrollTo({
				top: Math.max(offset.top - scrollOffset, 0),
				behavior: 'smooth',
			});
		}
	}

	/**
	 * Marks a listing to scroll to the top once its content refreshes.
	 */
	function queueListingScroll(listing) {
		if (!listing) {
			return;
		}

		listing._puhtiScrollAfterUpdate = true;
	}

	/**
	 * Finds the listing instance associated with a pagination control.
	 */
	function getListingFromPaginationElement(element) {
		var $pagination = jQuery(element).closest('.wpgmza-pagination');
		var $container = $pagination.parent();
		var $listing = jQuery();

		if (!$pagination.length) {
			return null;
		}

		$listing = $pagination.prevAll('[data-wpgmza-marker-listing]').first();

		if (!$listing.length) {
			$listing = $container.find('[data-wpgmza-marker-listing]').first();
		}

		if ($listing.length && $listing[0].wpgmzaMarkerListing) {
			return $listing[0].wpgmzaMarkerListing;
		}

		return null;
	}

	/**
	 * Updates the visible marker count above a single listing instance.
	 */
	function updateMarkerCount(listing) {
		if (!countLabel || !listing || !listing.element) {
			return;
		}

		var count = 0;

		if (
			listing.lastAJAXResponse &&
			typeof listing.lastAJAXResponse.recordsFiltered !== 'undefined'
		) {
			count = parseInt(listing.lastAJAXResponse.recordsFiltered, 10) || 0;
		}

		var $el = jQuery(listing.element);
		var $counter = $el.prev('.wpgmza-marker-count');

		if (!$counter.length) {
			$counter = jQuery('<p class="wpgmza-marker-count"></p>');
			$el.before($counter);
		}

		$counter.text(count + ' ' + countLabel);
	}

	/**
	 * Binds listing update event once per listing instance.
	 */
	function bindCounterEvent(listing) {
		if (!listing || listing._puhtiCounterBound) {
			return;
		}

		jQuery(listing).on('markerlistingupdated', function () {
			updateMarkerCount(listing);

			if (listing._puhtiScrollAfterUpdate) {
				listing._puhtiScrollAfterUpdate = false;
				scrollToListing(listing);
			}
		});

		if (listing.lastAJAXResponse) {
			updateMarkerCount(listing);
		}

		listing._puhtiCounterBound = true;
	}

	/**
	 * Finds existing listing instances from listing DOM nodes.
	 */
	function findExistingListings() {
		var result = [];

		jQuery('[data-wpgmza-marker-listing]').each(function () {
			if (this.wpgmzaMarkerListing) {
				result.push(this.wpgmzaMarkerListing);
			}
		});

		return result;
	}

	/**
	 * Hooks into WPGMZA listing AJAX lifecycle so count stays in sync
	 * after filtering, searching, and pagination changes.
	 */
	function patchMarkerListingPrototype() {
		if (
			prototypePatched ||
			!window.WPGMZA ||
			!WPGMZA.MarkerListing ||
			!WPGMZA.MarkerListing.prototype ||
			!WPGMZA.MarkerListing.prototype.onAJAXResponse
		) {
			return;
		}

		var originalOnAJAXResponse = WPGMZA.MarkerListing.prototype.onAJAXResponse;

		WPGMZA.MarkerListing.prototype.onAJAXResponse = function (response, textStatus, xhr) {
			originalOnAJAXResponse.call(this, response, textStatus, xhr);
			bindCounterEvent(this);
			updateMarkerCount(this);
		};

		prototypePatched = true;
	}

	var paginationScrollBound = false;

	/**
	 * Listens for pagination button clicks and flags the listing to
	 * scroll to top once the AJAX response arrives.
	 */
	function bindPaginationScrollEvents() {
		if (paginationScrollBound) {
			return;
		}

		document.addEventListener(
			'click',
			function (event) {
				var link = event.target.closest('.wpgmza-pagination .paginationjs-pages a');
				var listing = null;

				if (!link) {
					return;
				}

				listing = getListingFromPaginationElement(link);

				if (!listing) {
					return;
				}

				queueListingScroll(listing);

				window.setTimeout(function () {
					if (!listing._puhtiScrollAfterUpdate) {
						return;
					}

					listing._puhtiScrollAfterUpdate = false;
					scrollToListing(listing);
				}, 50);
			},
			true
		);

		paginationScrollBound = true;
	}

	/**
	 * Applies settings when WPGMZA / pagination become available.
	 * Retries briefly to handle script load order differences.
	 */
	function applyOverride() {
		retries++;

		var hasWPGMZA = !!(window.WPGMZA && WPGMZA.settings);
		var hasPagination = !!(
			window.jQuery &&
			jQuery.fn &&
			jQuery.fn.pagination &&
			jQuery.fn.pagination.defaults
		);

		if (hasWPGMZA) {
			WPGMZA.settings.wpgmza_default_items = String(pageSize);
			patchMarkerListingPrototype();

			findExistingListings().forEach(function (listing) {
				if (!listing) {
					return;
				}

				bindCounterEvent(listing);

				if (!listing._puhtiPageSizeApplied) {
					if (typeof listing.initPagination === 'function') {
						listing.initPagination();
					}

					if (typeof listing.reload === 'function') {
						listing.reload();
					}

					listing._puhtiPageSizeApplied = true;
				}

				updateMarkerCount(listing);
			});
		}

		if (hasPagination) {
			jQuery.fn.pagination.defaults.prevText = prevText;
			jQuery.fn.pagination.defaults.nextText = nextText;
			jQuery.fn.pagination.defaults.pageSize = pageSize;
			bindPaginationScrollEvents();
		}

		if (hasWPGMZA && hasPagination) {
			return;
		}

		if (retries < maxRetries) {
			window.setTimeout(applyOverride, 100);
		}
	}

	applyOverride();
})();
